"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.uniqueid"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CLASS_NAME = "body-overflow-media-manager-connector";
var css = "\n  [class*=\"".concat(CLASS_NAME, "\"]{\n    overflow: hidden;\n  }\n");

var MediaManagerConnector = /*#__PURE__*/function (_Component) {
  _inherits(MediaManagerConnector, _Component);

  var _super = _createSuper(MediaManagerConnector);

  function MediaManagerConnector(props) {
    var _this;

    _classCallCheck(this, MediaManagerConnector);

    _this = _super.call(this, props);
    _this.iframeEl = null;
    _this.handleLoad = _this.handleLoad.bind(_assertThisInitialized(_this));
    _this.processSingleAlienMessage = _this.processSingleAlienMessage.bind(_assertThisInitialized(_this));
    _this.handleMessage = _this.handleMessage.bind(_assertThisInitialized(_this));
    _this.uid = (0, _lodash["default"])();
    _this.el = document.createElement('div');

    _this.el.setAttribute('id', "media-manager-connector-placeholder-instance-".concat(_this.uid));

    _this.removeOverflowClass = _this.removeOverflowClass.bind(_assertThisInitialized(_this));
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
    return _this;
  }

  _createClass(MediaManagerConnector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.el);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.opened === true && nextProps.opened === false) {
        this.removeOverflowClass();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleMessage);
      document.body.removeChild(this.el);
      this.removeOverflowClass();
    }
  }, {
    key: "removeOverflowClass",
    value: function removeOverflowClass() {
      document.body.classList.remove("".concat(CLASS_NAME, "-").concat(this.uid));
    }
  }, {
    key: "handleLoad",
    value: function handleLoad() {
      document.body.classList.add("".concat(CLASS_NAME, "-").concat(this.uid));
      var _this$props = this.props,
          accessToken = _this$props.accessToken,
          appId = _this$props.appId,
          appSpace = _this$props.appSpace,
          onClose = _this$props.onClose,
          onSelectFiles = _this$props.onSelectFiles;
      window.removeEventListener('message', this.handleMessage);
      window.addEventListener('message', this.handleMessage, false);

      if (typeof onClose === 'function') {
        this.sendMessages([this.formatMessage('ON_CLOSE_FN_SET', appId)]);
      }

      if (typeof onSelectFiles === 'function') {
        this.sendMessages([this.formatMessage('ON_SELECT_FILES_FN_SET', this.props.multiple ? -1 : 1)]);
      }

      this.sendMessages([this.formatMessage('SET_APP_ID', appId), this.formatMessage('SET_ACCESS_TOKEN', accessToken)]);

      if (appSpace) {
        this.sendMessages([this.formatMessage('SET_APP_SPACE', appSpace)]);
      }
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(e) {
      if (Array.isArray(e.data)) {
        this.processAlienMessages(e.data);
      }
    }
  }, {
    key: "processAlienMessages",
    value: function processAlienMessages() {
      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      messages.forEach(this.processSingleAlienMessage);
    }
  }, {
    key: "processSingleAlienMessage",
    value: function processSingleAlienMessage(_ref) {
      var instanceId = _ref.instanceId,
          type = _ref.type,
          payload = _ref.payload;

      if (instanceId !== this.uid) {
        return;
      }

      var _this$props2 = this.props,
          onError = _this$props2.onError,
          onUnauthorized = _this$props2.onUnauthorized,
          onClose = _this$props2.onClose,
          onSelectFiles = _this$props2.onSelectFiles;

      switch (type) {
        case 'ERROR_GENERIC':
          if (typeof payload === 'string') {
            onError(payload);
          } else {
            throw Error("Unexpected error \"".concat(payload, "\"."));
          }

          break;

        case 'ERROR_AUTH':
          onUnauthorized();
          break;

        case 'CLOSE':
          onClose();
          this.removeOverflowClass();
          break;

        case 'FILES_SELECTED':
          onSelectFiles(payload);
          break;

        default:
      }
    }
  }, {
    key: "formatMessage",
    value: function formatMessage(type, payload) {
      return {
        instanceId: this.uid,
        type: type,
        payload: payload
      };
    }
  }, {
    key: "sendMessages",
    value: function sendMessages(messages) {
      this.iframeEl.contentWindow.postMessage(messages, '*');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          opened = _this$props3.opened,
          mediaManagerBaseUrl = _this$props3.mediaManagerBaseUrl;

      if (!opened) {
        return null;
      }

      return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("iframe", {
        frameBorder: "0",
        onLoad: this.handleLoad,
        ref: function ref(el) {
          _this2.iframeEl = el;
        },
        style: {
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 99999
        },
        title: "Media Manager",
        src: "".concat(mediaManagerBaseUrl, "/?instance_id=").concat(this.uid)
      }), this.el);
    }
  }]);

  return MediaManagerConnector;
}(_react.Component);

MediaManagerConnector.propTypes = {
  mediaManagerBaseUrl: _propTypes["default"].string,
  opened: _propTypes["default"].bool,
  appSpace: _propTypes["default"].string,
  appId: _propTypes["default"].string.isRequired,
  accessToken: _propTypes["default"].string.isRequired,
  onError: _propTypes["default"].func.isRequired,
  onUnauthorized: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  onSelectFiles: _propTypes["default"].func,
  multiple: _propTypes["default"].bool
};
MediaManagerConnector.defaultProps = {
  mediaManagerBaseUrl: 'https://mediamanager.sportnet.online',
  opened: false,
  onSelectFiles: null,
  multiple: true
};
var _default = MediaManagerConnector;
exports["default"] = _default;